import { render, staticRenderFns } from "./UserImportList.vue?vue&type=template&id=72a2dd20&"
import script from "./UserImportList.vue?vue&type=script&lang=js&"
export * from "./UserImportList.vue?vue&type=script&lang=js&"
import style0 from "./UserImportList.vue?vue&type=style&index=0&id=72a2dd20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports